// components/MenuItemsTable/CategorySection.js
import React from 'react';
import './CategoryList.css'

const CategorySection = ({
  categories,
  categoriesLoading,
  selectedCategory,
  onCategoryClick
}) => {
  const allCategory = {
    categoryName: 'ALL',
    dishId: null,
    image: 'https://cdn-icons-png.flaticon.com/512/1046/1046784.png'
  };

  return (
    <div 
  className="category-section-vikash" 
  style={{ 
    marginBottom: '20px', 
    padding: '0 12px',

    position: "sticky",
    top: "65px",   // 👈 mobile ke liye safe value
    zIndex: 999,
    background: "#fff",
    
  }}
>
      <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', color: '#333' }}>
        Explore Categories
      </h3>

      {categoriesLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '20px',
            height: '20px',
            border: '2px solid #f3f3f3',
            borderTop: '2px solid #ee6521',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span>Loading categories...</span>
        </div>
      ) : (
        <div style={{
          display: 'flex',
          gap: '12px',
          overflowX: 'auto',
          paddingBottom: '8px',
          scrollbarWidth: "none"
        }}>
          {[allCategory, ...categories].map(cat => (
  <div
    key={cat.dishId || cat.categoryName}
    onClick={() => onCategoryClick(cat)}
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minWidth: '60px',
      cursor: 'pointer',
      padding: '5px'
    }}
  >
    <div style={{
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      overflow: 'hidden',
      marginBottom: '6px',
      border: selectedCategory === cat.dishId
        ? '2px solid #ee6521'
        : '2px solid #ddd'
    }}>
      <img
        src={cat.dishImage || cat.image}
        alt={cat.dishName}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        onError={e => {
          e.target.src = "https://cdn-icons-png.flaticon.com/512/1046/1046784.png";
        }}
      />
    </div>

    <p style={{
      fontSize: '12px',
      fontWeight: selectedCategory === cat.dishId ? '600' : '400',
      color: selectedCategory === cat.dishId ? '#ee6521' : '#333',
      margin: 0,
      textAlign: 'center'
    }}>
      {cat.categoryName === 'ALL'
        ? 'All'
        : (cat.dishName?.length > 12
            ? cat.dishName.slice(0, 10) + '...'
            : cat.dishName)}
    </p>
  </div>
))}
        </div>
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default CategorySection;